// react
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import type { FallbackProps } from 'react-error-boundary';
// components
import MainContent from '@/components/Layout/components/MainContent';
import Navigation from '@/components/Layout/components/Navigation';
import ActReportDrawer from '@/modules/ActReportDrawer';
// utils
import { MENU_PORTAL, TOOLTIP_PORTAL, POPOVER_PORTAL } from '@/constants';

function fallbackRender({ error }: FallbackProps) {
    const message = error instanceof Error ? error.message : String(error);

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{message}</pre>
        </div>
    );
}

const Layout = () => {
    return (
        <>
            <Navigation />
            <MainContent>
                <ErrorBoundary fallbackRender={fallbackRender}>
                    <Outlet />
                </ErrorBoundary>
            </MainContent>
            <ActReportDrawer />
            <div id={TOOLTIP_PORTAL} />
            <div id={MENU_PORTAL} />
            <div id={POPOVER_PORTAL} />
        </>
    );
};

export default Layout;
